__turbopack_context__.v({
  "layout": "___9fq_layout",
  "overflowXHidden": "___9fq_overflowXHidden",
  "variantFullWidth": "___9fq_variantFullWidth",
  "variantPadded": "___9fq_variantPadded",
});
